import React from "react";
import Breadcrumbs from "components/common/Breadcrumbs";
import Text from "components/common/Text";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import StationDetail from "components/ChargingStationTable/StationDetail";
import ConfirmDeleteConnectorModel from "components/ChargingStationTable/ConfirmDeleteConnectorModel";
import ConfirmStatusConnectorModel from "components/ChargingStationTable/ConfirmStatusConnectorModel";
import ConfirmChargingPointModel from "components/ChargingStationTable/ConfirmChargingPointModel";
import { stationDetailApi } from "stores/StationDetailStore/stationDetailApi";

export default class StationDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteSuccess: false,
      enableSuccess: false,
      enableDisable: "",
      deleteConfirmConnectorDaialog: false,
      statusConfirmConnectorDaialog: false,
      chargingPointConfirmConnectorDaialog: false,
      ConnectorStatusId: "",
      ConnectorStatus: "",
      PointStatusId: "",
      PointStatus: "",
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;

    if (!id) {
      this.props.history.goBack();
    }
    this.props.getBasicDetailAction({ id });
  }

  componentDidUpdate() {
    if (this.state.deleteSuccess === true) {
      setTimeout(() => {
        this.props.getBasicDetailAction({ id: this.props.match.params.id });
        this.setState({ deleteSuccess: false });
      }, 100);
    }
  }
  handleStatusConfirmConnectorClick = (id, status) => {
    this.setState({
      statusConfirmConnectorDaialog: true,
      ConnectorStatus: status,
      ConnectorStatusId: id,
    });
  };

  handleConnectorStatusModelClose = () => {
    this.setState({
      statusConfirmConnectorDaialog: false,
      ConnectorStatus: "",
      ConnectorStatusId: " ",
    });
  };

  handleChargingPointConfirmClick = (id, status) => {
    this.setState({
      chargingPointConfirmConnectorDaialog: true,
      PointStatus: status,
      PointStatusId: id,
    });
  };

  handleConnectorChargingPointModelClose = () => {
    this.setState({
      chargingPointConfirmConnectorDaialog: false,
      PointStatus: "",
      PointStatusId: "",
    });
  };

  handleDeleteConfirmConnectorClick = (id) => {
    this.setState({
      deleteConfirmConnectorDaialog: true,
      deleteConnectorId: id,
    });
  };

  handleDeleteConnectorClick = async () => {
    let id = this.state.deleteConnectorId;

    if (id !== undefined) {
      await this.props.chargingPointDeleteAction({ id });
      this.setState({
        deleteConfirmConnectorDaialog: false,
        deleteConnectorId: "",
      });
      this.setState({ deleteSuccess: true });
      await this.props.getBasicDetailAction();
      this.setState({ deleteSuccess: false });
    }
  };

  handleCloseDeleteConnectorConfirm = () => {
    this.setState({ deleteConfirmConnectorDaialog: false });
  };

  handleEnableClickConnecter = async () => {
    const status = this.state.ConnectorStatus;
    const id = this.state.ConnectorStatusId;

    if (status === 1) {
      await stationDetailApi.chargingEnableDisable({ id, status: 0 });
      await this.props.getBasicDetailAction({ id: this.props.match.params.id });
    } else {
      await stationDetailApi.chargingEnableDisable({ id, status: 1 });
      await this.props.getBasicDetailAction({ id: this.props.match.params.id });
    }
    this.setState({ statusConfirmConnectorDaialog: false });
  };

  handleEnableClickChargingPoint = async () => {
    const status = this.state.PointStatus;
    const id = this.state.PointStatusId;

    if (status === 1) {
      await stationDetailApi.chargingPointEnableDisable({ id, status: 0 });
      this.setState({ PointStatus: 0 });

      await this.props.getBasicDetailAction({ id: this.props.match.params.id });
    } else {
      await stationDetailApi.chargingPointEnableDisable({ id, status: 1 });
      await this.props.getBasicDetailAction({ id: this.props.match.params.id });
    }

    this.setState({ chargingPointConfirmConnectorDaialog: false });
  };

  render() {
    const history = this.props.history;
    const props = {
      basicDetail: this.props.basicDetailData,
    };
    return (
      <>
        <Breadcrumbs
          sx={{
            fontSize: "14px",
            marginBottom: "20px",
            marginTop: "10px",
            color: "#a2a2a2",
          }}
        >
          <Text
            onClick={() => history.goBack()}
            sx={{ fontSize: "14px", cursor: "pointer", color: "#a2a2a2" }}
          >
            
            Charging Station
          </Text>

          <Text
            sx={{
              fontSize: "14px",
              color: "#a2a2a2",
            }}
            color="text.primary"
          >
            Station Details
          </Text>
        </Breadcrumbs>

        <StationDetail
          props={props}
          isLoading={this.props.isLoading}
          onDeleteClick={this.handleDeleteConfirmConnectorClick}
          onEnableClick={this.handleEnableClickChargingPoint}
          handleStatusConfirmConnectorClick={
            this.handleStatusConfirmConnectorClick
          }
          handleChargingPointConfirmClick={this.handleChargingPointConfirmClick}
          handleConnectorChargingPointModelClose={
            this.handleConnectorChargingPointModelClose
          }
        />

        <Snackbar
          open={this.state.deleteSuccess}
          autoHideDuration={3000}
          onClose={() => this.setState({ deleteSuccess: false })}
          message="Charging Station Deleted Successfully"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="error">
            Charging Connecter Deleted Successfully
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.state.enableSuccess}
          autoHideDuration={3000}
          onClose={() => this.setState({ enableSuccess: false })}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="warning">
            Charging Connecter Status Changed Successfully
          </Alert>
        </Snackbar>

        <ConfirmDeleteConnectorModel
          open={this.state.deleteConfirmConnectorDaialog}
          handleClose={this.handleCloseDeleteConnectorConfirm}
          handleDelete={this.handleDeleteConnectorClick}
        />

        <ConfirmStatusConnectorModel
          open={this.state.statusConfirmConnectorDaialog}
          handleEnable={this.handleEnableClickConnecter}
          handleclose={this.handleConnectorStatusModelClose}
          ConnectorStatus={this.state.ConnectorStatus}
        />

        <ConfirmChargingPointModel
          open={this.state.chargingPointConfirmConnectorDaialog}
          handleEnablepoint={this.handleEnableClickChargingPoint}
          handleclosepoint={this.handleConnectorChargingPointModelClose}
          PointStatus={this.state.PointStatus}
        />
      </>
    );
  }
}
